import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

export const toISODate = (value) => {
  if (!value) return '';
  const raw = String(value).trim();
  const isoCandidate = raw.split('T')[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoCandidate)) return isoCandidate;
  const [day, month, year] = raw.split('-');
  if (/^\d{2}$/.test(day) && /^\d{2}$/.test(month) && /^\d{4}$/.test(year)) {
    return `${year}-${month}-${day}`;
  }
  const monthMap = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };
  if (!day || !month || !year || !monthMap[month]) return '';
  return `${year}-${monthMap[month]}-${day}`;
};

export const toPickerDate = (value) => {
  const iso = toISODate(value);
  return iso ? dayjs(iso) : null;
};

export const fromPickerDate = (value) => (
  value && typeof value.isValid === 'function' && value.isValid()
    ? value.format('YYYY-MM-DD')
    : ''
);

let approvalLinkIdSeed = 0;
export const createApprovalLinkItem = (value = '') => {
  approvalLinkIdSeed += 1;
  return { id: `approval-link-${approvalLinkIdSeed}`, value };
};

export const normalizeApprovalLinks = (links) => {
  if (!Array.isArray(links) || links.length === 0) return [createApprovalLinkItem('')];
  return links.map((link) => {
    if (link && typeof link === 'object' && link.id) {
      return { id: String(link.id), value: String(link.value || '') };
    }
    return createApprovalLinkItem(String(link || ''));
  });
};

export const ModalShell = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'medium',
  headerAction = null,
  modalClassName = '',
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => onClose();

  return (
    <div className="modal-overlay">
      <div
        className="modal-backdrop"
        onClick={handleBackdropClick}
        aria-hidden="true"
      />
      <div className={`modal-container ${size} ${modalClassName}`.trim()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          {headerAction ? (
            <div className="modal-header-action">
              {headerAction}
            </div>
          ) : null}
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
};

ModalShell.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  headerAction: PropTypes.node,
  modalClassName: PropTypes.string,
};
